<template>
	<layout-admin>
		<admin-crop-grid
			:title="title"
			:rows="data"
			:cols="cols"
			v-bind:row-href="rowHref"
			defaultOrderBy="id"
			:defaultOrderByAscending="true"
		>
		<template v-slot:actions>
			<div>
				<!-- Create Subscription -->
				<ui-button
					class="flex items-center flex-shrink-0"
					v-on:click="
						$bus.$emit('modal:open', {
							view: {
								view: 'views/Admin/SubscriptionCreate',
								data: { amount: 178.5, subscription_id: 1 }
							}
						})
					"
				>
					<ui-icon
						class="mr-2 -ml-1 flex-shrink-0 h-5 w-5 text-white"
						name="plus"
						stroke-width="2"
					/>
					<span class="">{{ __("New free subscription") }}</span>
				</ui-button>

			</div>
		</template>
		</admin-crop-grid>
	</layout-admin>
</template>

<script>
let options = require("../../cropOptions");

export default {
	props: {
		data: {
			type: Array,
			required: true,
		},
		statusOptions: {
			type: Array,
			required: true,
		},
		paymentStatusOptions: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			title: this.__("Subscriptions"),
			cols: [
				{
					id: "id",
					name: "ID",
					render: (id) => "#" + id,
				},
				{
					id: "name",
					name: this.__("User"),
					render: (x, row) => {
						if(row.user.status === "DISABLED") {
							return row.user.name + ' (' + __("gesperrt") + ')';
						}

						return row.user.name;
					},
				},
				{
					id: "user_id",
					name: this.__("User-ID"),
					render: (x, row) => row.user_id,
				},
				{
					id: "status",
					name: this.__("Status"),
					render: (x, row) => __(row.status),
					filterOptions: this.statusOptions
						.map((o) => {
							return {
								id: __(o),
								name: __(o),
							};
						}),
				},
				{
					id: "payment_status",
					name: this.__("payment_status"),
					render: (x, row) => __(row.payment_status),
					filterOptions: this.paymentStatusOptions
						.map((o) => {
							return {
								id: __(o),
								name: __(o),
							};
						}),
				},
				{
					id: "payment_method_label",
					name: this.__("Payment Method"),
					render: (x, row) => __(row.payment_method_label),
				},
				{
					id: "invoice_sent_at",
					name: this.__("Rechnung versendet"),
					render: (x, row) => row.invoice_sent_at ? __('Yes') : __('No'),
					filterOptions: [{ id: __("Yes"), name: __("Yes") }, { id: __("No"), name: __("No") }]
				},
				{
					id: "trial_until",
					name: this.__("Ende Testphase"),
					render: options.formatIsoStamp,
				},
				{
					id: "billing_reminder_at",
					name: this.__("Zahlungsankündigung"),
					render: options.formatIsoStamp,
				},
				{
					id: "valid_from",
					name: this.__("Von"),
					render: options.formatIsoStamp,
				},
				{
					id: "valid_until",
					name: this.__("Bis"),
					render: options.formatIsoStamp,
				},
				{
					id: "terminated_at",
					name: this.__("Gekündigt"),
					render: (x, row) => row.terminated_at ? __('Yes') : __('No'),
				},
				{
					id: "created_at",
					name: this.__("Created"),
					render: options.formatIsoStamp,
				},
			],
		};
	},
	methods: {
		rowHref(row) {
			// todo route
			return window.baseUrl + "/admin/subscriptions/" + row.id.replace("#", "");
		},
	},
};
</script>
